import {isAdminAuthenticated} from "../common/server";
import {Navigate, useLocation} from "react-router-dom";


function AdminRoute({children}) {
    const location = useLocation();

    return isAdminAuthenticated()? children : <Navigate to="/shop/login" replace state={{from: location}}/>;
}

export default AdminRoute;